import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import {parseDateTimestamp} from "./parseDateTimestamp";

dayjs.extend(calendar);

type CalendarFormats = {
    sameDay: string;
    nextDay: string;
    nextWeek: string;
    lastDay: string;
    lastWeek: string;
    sameElse: string;
};

// Omit `formats` to use the locale's calendar config (set in @atg-shared/language initDayjs)
export const calendarUtil = (time: string, formats?: Partial<CalendarFormats>) =>
    parseDateTimestamp(time).calendar(null, formats);
